module.exports = __webpack_public_path__ + "img/nav-logo.4d888eda.jpg";